import { createContext, useContext } from "react";
import type { AdminMe } from "@paceroo/domain/views/admin";
import type { Breakpoint } from "../lib/useBreakpoint";

export interface ShellApi {
  me: AdminMe;
  bp: Breakpoint;
  /** Focus the runner search (opens the full-screen sheet on mobile). */
  focusSearch: () => void;
  /** Overview reports when its numbers last arrived ("Updated 08:12"). */
  setUpdated: (at: Date | null) => void;
  /** Bottom-centre confirmation that dismisses itself after 6 s. */
  toast: (text: string) => void;
}

export const ShellContext = createContext<ShellApi | null>(null);

export function useShell(): ShellApi {
  const api = useContext(ShellContext);
  if (!api) throw new Error("useShell outside <Shell>");
  return api;
}
